import axios from "axios";



export async function callGetAPI(apiURL) {
    console.log("Inside callGetAPI and apiURL is =====> ", apiURL);
    // debugger;
    const response = await axios
        .get(apiURL)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    // debugger;
    return response.data;
}